import { render, staticRenderFns } from "./accomodationCategory.vue?vue&type=template&id=547a3467"
import script from "./accomodationCategory.vue?vue&type=script&lang=js"
export * from "./accomodationCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports